export default __webpack_public_path__ + "static/media/smallEarth.df91e7d5.png";